<template>
  <div class="messenger-chat-window" ref="content">
    <div class="messenger-history">
      <infinite-loading direction="top" @infinite="fetchStream"></infinite-loading>
      <div
        v-for="message in messages"
        :key="message.id"
        class="messenger-history__item"
      >
        <message
          v-if="message.type === 'message'"
          :message="message.entry"
          :transport-type="currentClient.transport_type"
        />

        <session-history
          v-if="message.type === 'session_history'"
          :message="message.entry"
        />

        <internal-comment
          v-if="message.type === 'internal_comment'"
          :message="message.entry"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Stream from '@/api/http/models/Stream'
import WebSocketService from '@/api/ws/WebSocketService'

import { mapGetters } from 'vuex'

import Message from './messages/Message.vue'
import SessionHistory from './messages/SessionHistory.vue'
import InternalComment from './messages/InternalComment.vue'

export default {
  components: {
    InternalComment,
    SessionHistory,
    Message
  },

  data () {
    return {
      scrollOffsetBottom: 500,
      showButton: false,
      start: false,
      messages: [],
      nextCursor: null,
      subscription: {}, // websocket subscribe
      newMessageSound: new Audio(require('@/assets/sounds/new-message-sound.ogg'))
    }
  },

  computed: mapGetters(['authUserCompany', 'currentClient']),

  async created () {
    const service = new WebSocketService()

    this.subscription = service.socket.subscribe(this.currentClient.chat_id, response => {
      if (
        response.data.type === 'message' ||
          response.data.type === 'internal_comment' ||
          response.data.type === 'session_history'
      ) {
        this.addMessage(response.data)
      }

      if (response.data.type === 'ack') {
        this.setMessageACK(response.data.entry)
      }

      // Воспроизведение звука
      if (response.data.type === 'message' && response.data.entry.sender_type === 'client') {
        this.newMessageSound.play()
      }
    })
  },

  methods: {
    async fetchStream ($state) {
      const response = await Stream.fetch(this.authUserCompany.slug, this.currentClient.client_id, this.nextCursor)

      await this.messages.unshift(...response.data)

      if (response.meta.next_cursor === null) {
        $state.complete()
      } else {
        $state.loaded()
        this.nextCursor = response.meta.next_cursor
      }

      // Скроллить вниз чата в первую подгрузку
      if (!this.start) {
        this.start = true
        this.scrollToBottom()
      }
    },

    scrollToBottom () {
      this.$refs.content.parentElement.scrollTop = this.$refs.content.parentElement.scrollHeight
    },

    async addMessage (message) {
      // Скроллить вниз только если пользователь находится не выше scrollOffsetBottom
      const $content = this.$refs.content.parentElement
      const scroll = (
        $content.scrollTop + $content.offsetHeight + this.scrollOffsetBottom >=
          $content.scrollHeight
      )
      await this.messages.push(message)
      if (scroll) this.scrollToBottom()
    },

    setMessageACK (ack) {
      const index = this.messages.findIndex(msg => ack.event_stream_id === msg.id)
      if (ack.viewed_at) {
        this.messages[index].entry.viewed = true
        this.messages[index].entry.delivered = true
      } else {
        this.messages[index].entry.delivered = true
      }
    },

    handleScrollContent () {
      const $c = this.$refs.content.parentElement

      this.showButton = (
        $c.scrollHeight - ($c.scrollTop + $c.offsetHeight) > this.scrollOffsetBottom
      )
    }
  },

  beforeDestroy () {
    this.subscription.unsubscribe()
  }
}
</script>
